import { createContext, useContext } from 'react';
export const RoomMetaContext = createContext(null);
export const useMaybeRoomMeta = () => {
    const meta = useContext(RoomMetaContext);
    return meta;
};
